import { State as SettingsState } from "@client/reducers/settings-reducer";
import { Selector } from "@ngrx/store";
export const getIsActive: Selector<SettingsState, boolean> = (state: SettingsState) => state.isActive;
export const getIsEditable: Selector<SettingsState, boolean> = (state: SettingsState) => state.isEditable;
export const getIsAddable: Selector<SettingsState, boolean> = (state: SettingsState) => state.isAddable;
export const getSubTitle: Selector<SettingsState, string | null> = (state: SettingsState) => state.subTitle;
export const getEditLink: Selector<SettingsState, string | null> = (state: SettingsState) => state.editLink;
export const getAddLink: Selector<SettingsState, string | null> = (state: SettingsState) => state.addLink;
export const getBackLink: Selector<SettingsState, string | null> = (state: SettingsState) => state.backLink;
